import { manifest as isTrashedManifest } from './is-trashed/entity-is-trashed.condition.manifest.js';
import { manifest as isNotTrashedManifest } from './is-not-trashed/entity-is-not-trashed.condition.manifest.js';

export const manifests = [isTrashedManifest, isNotTrashedManifest];
